<template>
  <a href="#" @click.prevent="()=> clickFn()" :aria-label="altTitle">
    <div class="inner-wrap" aria-hidden="true">

      <div class="picture-area">
        <picture>
          <img :src="getThumbnailImg" @load="onImageLoad" :alt="altTitle" />
        </picture>

        <AgeTag v-if="ageTag.hasAgeTag" :age-code="ageTag.ageCode" />

        <ul class="badge-list">
          <li class="left-top-area">
            <ul v-top-tag-list="{ badgeList: topTagList, badgeType: 'artwork' }" />
          </li>
        </ul>

        <div :class="altClassName">
          <span>{{ altTitle }}</span>
        </div>

        <div class="progress" v-if="isProgress">
          <span class="progress-meter" v-progress-bar="progress * 100">&nbsp;</span>
        </div>
      </div>

      <div class="cell-info">
        <div class="cell-title-wrap" v-title-list="{ titleList: titleList }" />
      </div>
    </div>
  </a>
</template>

<script>
import { get } from 'lodash'
import { progressBar, titleList, topTagList, commonTagList } from '@/common/directives'
import AgeTag from '@/components/tags/AgeTag'
import cellMixin from '@/common/mixin/cell.mixin'

export default {
  name: 'RelatedLandscapeCell',
  components: {
    AgeTag
  },
  mixins: [ cellMixin ],
  directives: {
    progressBar,
    titleList,
    topTagList,
    commonTagList
  },
  props: {
    cellInfo: {
      type: Object,
      default: () => {}
    },
    thumbnailInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ageTag () {
      const ageCode = get(this.cellInfo, 'age_tag', '')
      const hasAgeTag = ageCode !== ''
      return { ageCode, hasAgeTag }
    }
  },
  methods: {
    clickFn () {
      this.$emit('click-fn')
    }
  }
}
</script>
